module.exports = __webpack_public_path__ + "assets/images/50R.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/50R.png
// module id = 1306
// module chunks = 1